var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.668,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_182_76)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1418 33.168C18.9538 31.2224 18.3274 28.986 18.3321 26.7064C18.3321 19.7809 24.0036 14.168 30.9987 14.168C37.9939 14.168 43.6654 19.7809 43.6654 26.7064C43.6701 28.986 43.0437 31.2224 41.8556 33.168",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.748 41.0859L35.5421 42.1104C35.3205 43.2298 35.2081 43.7887 34.9563 44.232C34.5684 44.9153 33.9403 45.43 33.1941 45.676C32.7111 45.8359 32.138 45.8359 30.998 45.8359C29.858 45.8359 29.2848 45.8359 28.8019 45.6776C28.0554 45.4312 27.4273 44.9159 27.0396 44.232C26.7879 43.7887 26.6755 43.2298 26.4538 42.1104L26.248 41.0859M23.6877 38.0744C23.5421 37.6374 23.4692 37.4174 23.4771 37.24C23.4861 37.0567 23.548 36.8798 23.6553 36.7309C23.7627 36.582 23.9109 36.4673 24.082 36.4009C24.2466 36.3359 24.4778 36.3359 24.937 36.3359H37.059C37.5197 36.3359 37.7493 36.3359 37.914 36.3993C38.0853 36.4659 38.2337 36.5807 38.341 36.73C38.4484 36.8792 38.5102 37.0564 38.5188 37.24C38.5267 37.4174 38.4539 37.6359 38.3082 38.0744C38.0391 38.8835 37.9045 39.2889 37.6971 39.6166C37.2632 40.3016 36.5832 40.794 35.7971 40.9925C35.4202 41.0859 34.9959 41.0859 34.1456 41.0859H27.8503C27.0001 41.0859 26.5741 41.0859 26.1989 40.9909C25.413 40.7928 24.733 40.301 24.2989 39.6166C24.0915 39.2889 23.9569 38.8835 23.6877 38.0744Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_76",
    x1: 30.668,
    y1: 0,
    x2: 30.668,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.63503bc67380eb2141229e08706e099a.svg";
export { ForwardRef as ReactComponent };